export default __webpack_public_path__ + "ce1c808e3e8d86b6c50eaab0ed7a3bd9.png";